import { SectionCaption } from '@app/core/components/SectionCaption';
import { MessageDescriptor } from 'react-intl';

interface SectionHeaderProps {
  message: MessageDescriptor;
  count: number;
  values?: Record<string, string | number>;
}

/**
 * Secondary heading for a status-screen station group (favorites, own, shared, or named group).
 */
export function SectionHeader({ message, count, values }: SectionHeaderProps) {
  return <SectionCaption message={message} values={{ count, ...values }} />;
}
